import $ from "jquery";
import Test from "./test";

$(() => {
	const test = new Test({ questions: QUESTIONS });
	test.init();

	$(".health__arrow").on("click", function () {
		$([document.documentElement, document.body]).animate(
			{
				scrollTop: $(".advice").offset().top,
			},
			500
		);
	});
});



// WEBPACK FOOTER //
// ./app/scripts/app.js